import { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import LoadingSpinner from '../../common/LoadingSpinner';

const DeleteConfigItemModal = ({ show, item, onConfirm, onClose }) => {
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isCompany = item?.type === 'company';
  const itemName = isCompany ? item?.companyLong : item?.fundTypeLong;
  const itemAbbrev = isCompany ? item?.companyShort : item?.fundTypeShort;
  const itemTypeLabel = isCompany ? 'company' : 'fund type';

  const handleConfirm = async () => {
    setError('');
    setSubmitting(true);

    const result = await onConfirm();
    setSubmitting(false);

    if (!result.success) {
      setError(result.error || `Failed to delete ${itemTypeLabel}.`);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Modal show={show && !!item} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-danger">
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p>Are you sure you want to delete this {itemTypeLabel}?</p>
        <p><strong>Name:</strong> {itemName}</p>
        <p><strong>Abbreviation:</strong> {itemAbbrev}</p>

        <Alert variant="warning" className="mt-3 mb-0">
          <strong>Warning:</strong> This action cannot be undone.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={submitting}>
          {submitting ? (
            <LoadingSpinner inline message="Deleting..." />
          ) : (
            'Delete'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfigItemModal;
